import type { IManualPoint, IPointHistory, IPointRule, IPointSetting } from '@/types/Data'
import type {
  ICreateManualPoint,
  ICreatePointRule,
  IGetManualPointList,
  IGetPointHistory,
  IPaging,
  IUpdatePointSetting,
} from '@/types/Request'
import BaseService from '../BaseService'

export default class PointCreditServices extends BaseService {
  GetPointSettingList() {
    return this.GET<IPointSetting[]>(this.PATHS.GET_POINT_SETTING_LIST)
  }

  UpdatePointSetting(payload: IUpdatePointSetting) {
    return this.POST<void>(this.PATHS.UPDATE_POINT_SETTING, payload)
  }

  GetPointRuleList(payload: IPaging) {
    return this.GET<IPointRule[]>(this.PATHS.GET_POINT_RULE_LIST, payload)
  }

  CreatePointRule(payload: ICreatePointRule) {
    return this.POST<IPointRule>(this.PATHS.CREATE_POINT_RULE, payload)
  }

  DeletePointRule(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_POINT_RULE, { Id })
  }

  GetManualPointList(payload: IGetManualPointList) {
    return this.GET<IManualPoint>(this.PATHS.GET_MANUAL_POINT_LIST, payload)
  }

  GetManualPointListExcel(payload: IGetManualPointList) {
    return this.EXCEL(this.PATHS.GET_MANUAL_POINT_LIST, false, payload)
  }

  CreateManualPoint(payload: ICreateManualPoint) {
    return this.POST<void>(this.PATHS.CREATE_MANUAL_POINT, payload)
  }

  ResetDistributablePoint() {
    return this.POST<void>(this.PATHS.RESET_DISTRIBUTABLE_POINT, { IsTest: true })
  }

  ResetSpendablePoints() {
    return this.POST<void>(this.PATHS.RESET_SPENDABLE_POINT, { IsTest: true })
  }

  GetPointHistory(payload: IGetPointHistory) {
    return this.POST<IPointHistory[]>(this.PATHS.GET_POINT_HISTORY, payload)
  }
}
